module.exports = __webpack_public_path__ + "img/gift-cards-3.928419db.png";